import { zodResolver } from "@hookform/resolvers/zod";
import React from "react";
import { Button } from "@/components/ui/button";
import { useForm, FieldPath } from "react-hook-form";
import { Form, FormLabel } from "@/components/ui/form";
import FormFieldInput from "../../FormField/FormFieldInput";
import FormSection from "../../FormSection/FormSection";
import { EditUserFormValuesType, stakeholderSchema } from "../schemas";
import SearchLocation from "../../SearchLocation/SearchLocation";
import { Trash } from "lucide-react";
import ParcelPreview from "../../ParcelPreview/ParcelPreview";
import { formatPostalCode } from "@/src/lib/postalCode";
type EditUserFormPropsType = {
  onSubmit: (values: EditUserFormValuesType) => void;
  defaultValues?: Partial<EditUserFormValuesType>;
};
function EditUserForm({ onSubmit, defaultValues }: EditUserFormPropsType) {
  {
    const form = useForm<EditUserFormValuesType>({
      resolver: zodResolver(stakeholderSchema),
      defaultValues: defaultValues || {
        name: "",
        country: "",
        voivodeship: "",
        district: "",
        tenant: "",
        street: "",
        houseNumber: "",
        town: "",
        apartmentNumber: "",
        postalCode: "",
        email: "",
        phone: "",
        epuapAdress: "",
        parcels: [],
      },
    });

    const handlePostalCodeChange =
      (fieldName: FieldPath<EditUserFormValuesType>) => (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = formatPostalCode(e.target.value);
        form.setValue(fieldName, value, {
          shouldValidate: true,
          shouldDirty: true,
          shouldTouch: true,
        });
        stakeholderSchema.parse(value);
      };
    return (
      <Form {...form}>
        <form onSubmit={form.handleSubmit(onSubmit)}>
          <FormSection title="Dane kontaktowe" isCollapsible defaultOpen>
            <FormFieldInput
              form={form}
              description=""
              placeholder="Imię i nazwisko lub nazwa"
              label="Imię i nazwisko lub nazwa"
              name="name"
            />
            <FormFieldInput form={form} description="" placeholder="Kraj" label="Kraj" name="country" />
            <FormFieldInput
              form={form}
              description=""
              placeholder="Wojewódźtwo"
              label="Wojewódźtwo"
              name="voivodeship"
            />
            <FormFieldInput form={form} description="" placeholder="Powiat" label="Powiat" name="district" />
            <FormFieldInput form={form} description="" placeholder="Gmina" label="Gmina" name="tenant" />
            <div className="flex gap-2">
              <FormFieldInput
                form={form}
                description=""
                placeholder="Ulica"
                label="Ulica"
                name="street"
                className="w-1/2"
              />
              <FormFieldInput
                form={form}
                description=""
                placeholder="Numer domu"
                label="Numer domu"
                name="houseNumber"
                className="w-1/4"
              />
              <FormFieldInput
                form={form}
                description=""
                placeholder="Numer mieszkania"
                label="Numer mieszkania"
                name="apartmentNumber"
                className="w-1/4"
              />
            </div>
            <FormFieldInput form={form} description="" placeholder="Miasto" label="Miasto" name="town" />
            <FormFieldInput
              form={form}
              description=""
              placeholder="Kod pocztowy"
              label="Kod pocztowy"
              name="postalCode"
              onChange={handlePostalCodeChange("postalCode")}
            />
            <FormFieldInput disabled form={form} description="" placeholder="E-mail" label="E-mail" name="email" />
            <FormFieldInput form={form} description="" placeholder="Nr. telefonu" label="Nr. telefonu" name="phone" />
            <FormFieldInput
              form={form}
              description=""
              placeholder="Adres ePUAP"
              label="Adres ePUAP"
              name="epuapAdress"
            />
          </FormSection>
          <FormLabel>Moje działki</FormLabel>
          <ul>
            {form.getValues("parcels") &&
              form.getValues("parcels")!.map((parcel, _id, parclesArray) => {
                return (
                  <li>
                    <div className="flex gap-2">
                      {parcel.id}{" "}
                      <Trash
                        className="cursor-pointer"
                        onClick={() => {
                          form.setValue(
                            "parcels",
                            parclesArray.filter(({ id }) => parcel.id !== id),
                          );
                        }}
                      />
                      <ParcelPreview parcel={parcel as any} />
                    </div>
                  </li>
                );
              })}
          </ul>
          <SearchLocation
            addParcels={(parcels) => {
              const current = form.getValues("parcels") || [];
              form.setValue("parcels", [...parcels, ...current] as any);
            }}
          />
          <Button className="block my-2" type="submit">
            Zapisz
          </Button>
        </form>
      </Form>
    );
  }
}

export default EditUserForm;
